import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'typename'
})
export class ShareTypeNamePipe implements PipeTransform
{
    public transform(value: string): string 
    {
        switch (value)
        {
            case '3/2':
                return 'Megalod';
            case '1/1':
                return '1/1 lod';
            case '1/2':
                return '1/2 lod';
            case '1/4':
                return '1/4 lod';
            case '1/8':
                return '1/8 lod';

            default: throw new Error('? lod');
        }
    }
}
